import { ExclusionType } from '../../exclusion-type'
import { ExclusionInputType } from '../../exclusion-input-type'
import { UrlPatternType } from '../../url-pattern-type'
import { BaseAssessRule } from '../../../assess-rules'
import { BaseProtectRule } from '../../../protect-rules/shared'
import { BaseApiResponse } from '../../../../api/shared'
import { QueuePatternType } from '../../queue-pattern-type'

export interface ExclusionRequest {
  name: string
  type: ExclusionType
  allRules: boolean
  allAssessRules: boolean
  allProtectRules: boolean
  assessRules: string[]
  protectRules: string[]
  codes: string[]
  urls: string[]
  queues: string[]
  inputType?: ExclusionInputType
  inputName?: string
  urlPatternType?: UrlPatternType
  queuePatternType?: QueuePatternType
  eventUuid?: string
}

export interface ExclusionApiRequest {
  name: string
  type: ExclusionType
  all_rules: boolean
  all_assessment_rules: boolean
  all_protection_rules: boolean
  assessment_rules: string[]
  protection_rules: string[]
  codes: string[]
  urls: string[]
  queues: string[]
  input_type?: ExclusionInputType
  input_name?: string
  url_pattern_type?: UrlPatternType
  queue_pattern_type?: QueuePatternType
  event_uuid?: string
}

export interface ExclusionApi {
  exception_id: number
  name: string
  type: ExclusionType
  input_type: ExclusionInputType
  input_name: string
  url_pattern_type: UrlPatternType
  queue_pattern_type: QueuePatternType
  urls: string[]
  codes: string[]
  queues: string[]
  all_rules: boolean
  assess: boolean
  all_assessment_rules: boolean
  assess_rules: BaseAssessRule[]
  defend: boolean
  all_protection_rules: boolean
  protection_rules: BaseProtectRule[]
}

export interface Exclusion {
  exceptionId: number
  name: string
  type: ExclusionType
  inputType: ExclusionInputType
  inputName: string
  urlPatternType: UrlPatternType
  queuePatternType: QueuePatternType
  urls: string[]
  queues: string[]
  codes: string[]
  allRules: boolean
  assess: boolean
  allAssessRules: boolean
  assessRules: BaseAssessRule[]
  defend: boolean
  allProtectRules: boolean
  protectRules: BaseProtectRule[]
}

export interface ExclusionApiResponse extends BaseApiResponse {
  exception: ExclusionApi
}

export interface ExclusionRequestArgs {
  organizationUuid: string
  applicationId: string
  exclusionId: string
}

export const normalizeExclusionRequest = ({
  name,
  type,
  allRules,
  allAssessRules,
  allProtectRules,
  assessRules,
  protectRules,
  codes,
  urls,
  queues,
  inputName,
  inputType,
  urlPatternType,
  queuePatternType,
  eventUuid
}: ExclusionRequest): ExclusionApiRequest => ({
  name,
  type,
  all_rules: allRules,
  all_assessment_rules: allAssessRules,
  all_protection_rules: allProtectRules,
  assessment_rules: assessRules,
  protection_rules: protectRules,
  codes,
  urls,
  queues,
  input_name: inputName,
  input_type: inputType,
  url_pattern_type: urlPatternType,
  queue_pattern_type: queuePatternType,
  event_uuid: eventUuid
})

export function normalizeExclusionResponse({
  exception_id: exceptionId,
  name,
  type,
  input_type: inputType,
  input_name: inputName,
  url_pattern_type: urlPatternType,
  queue_pattern_type: queuePatternType,
  urls,
  queues,
  codes,
  all_rules: allRules,
  assess,
  all_assessment_rules: allAssessRules,
  assess_rules: assessRules,
  defend,
  all_protection_rules: allProtectRules,
  protection_rules: protectRules
}: ExclusionApi): Exclusion {
  return {
    exceptionId,
    name,
    type,
    inputType,
    inputName,
    urlPatternType,
    queuePatternType,
    urls,
    queues,
    codes,
    allRules,
    assess,
    allAssessRules,
    assessRules:
      Array.isArray(assessRules) && assessRules.length > 0
        ? assessRules.map(({ name: ruleName, title }) => ({
            name: ruleName,
            title
          }))
        : [],
    defend,
    allProtectRules,
    protectRules:
      Array.isArray(protectRules) && protectRules.length > 0
        ? protectRules.map(({ displayName, uuid }) => ({
            displayName,
            uuid
          }))
        : []
  }
}
